import type * as Blockly from 'blockly/core';
import { create } from 'zustand';
import type { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

interface BlockModalVariableState {
    workspace: Blockly.WorkspaceSvg | null;
    fieldRef: FieldVariableLabel | null;
    filterType: 'float' | 'String' | 'bool' | null;
    setWorkspace: (ws: Blockly.WorkspaceSvg | null) => void;
    setFieldRef: (field: FieldVariableLabel | null) => void;
    setFilterType: (type: 'float' | 'String' | 'bool' | null) => void;
}

export const useBlockModalVariableStore = create<BlockModalVariableState>((set) => ({
    workspace: null,
    fieldRef: null,
    filterType: null,
    setWorkspace: (ws) => set({ workspace: ws }),
    setFieldRef: (field) => set({ fieldRef: field }),
    setFilterType: (type) => set({ filterType: type }),
}));
